import { Outlet } from 'react-router-dom'

const VoucherBooking = () => <Outlet />

export default VoucherBooking
